var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flyout-cart", class: { "is-open": _vm.isOpen } },
    [
      _c("header", [
        _c("h3", { staticClass: "flyout-cart-title" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "flyout-cart-subtitle" }, [
          _vm._v(_vm._s(_vm.subtitle))
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "flyout-cart-close",
            attrs: {
              "aria-label": _vm.closeButtonLabel,
              tabindex: _vm.isOpen === false ? -1 : 0
            },
            on: {
              click: function($event) {
                _vm.isOpen = false
              }
            }
          },
          [
            _c("svg", { staticClass: "icon icon-close" }, [
              _c("use", { attrs: { "xlink:href": "#icon-close" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "scrollTarget", staticClass: "line-items" },
        [
          !_vm.isEmpty
            ? _c("header", [
                _c("span", { staticClass: "line-items-header-item" }, [
                  _vm._v(_vm._s(_vm.productLabel))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "line-items-header-item" }, [
                  _vm._v(_vm._s(_vm.quantityLabel))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.items, function(item) {
            return _c(item.component, {
              key: "" + item.id + item.price,
              tag: "component",
              attrs: {
                "compare-price": _vm._f("money")(
                  item.compareAtPrice,
                  _vm.moneyFormat
                ),
                "image-alt": item.image.alt,
                "image-src": item.image.src,
                "is-focusable": _vm.isOpen,
                multiplier: item.multiplier,
                properties: item.properties,
                quantity: item.quantity,
                "remove-label": _vm.removeLabel,
                "subscription-label": _vm.subscriptionLabel,
                subtitle: item.subtitle,
                title: item.title,
                price: _vm._f("money")(item.price, _vm.moneyFormat),
                url: item.url,
                "variant-id": item.id,
                "flash-message": item.flashMessage,
                "selling-plan-allocation": item.sellingPlanAllocation
              },
              on: {
                update: function($event) {
                  return _vm.updateItem({ item: item, quantity: $event })
                },
                remove: function($event) {
                  return _vm.removeItem({ item: item })
                }
              }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("footer", [
        _vm.subTotal > 0
          ? _c("span", { staticClass: "flyout-cart-subtotal" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("money")(_vm.subTotal, _vm.moneyFormat)) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.subTotal > 0
          ? _c("span", { staticClass: "flyout-cart-footer-text" }, [
              _vm._v("\n      " + _vm._s(_vm.taxesAndShippingLabel) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "checkout",
            staticClass: "button-segmented button-segmented-grey",
            attrs: {
              tabindex: _vm.isOpen === false ? -1 : 0,
              "aria-label": _vm.checkoutButtonLabel,
              type: "button"
            },
            on: { click: _vm.onCheckoutButtonClick }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.checkoutButtonLabel))]),
            _vm._v(" "),
            _c("svg", { staticClass: "icon icon-arrow-right" }, [
              _c("use", { attrs: { "xlink:href": "#icon-arrow-right" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "flyout-cart-overlay",
        on: {
          click: function($event) {
            _vm.isOpen = !_vm.isOpen
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }